import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { DeleteIconComponent } from '@kuiper/icons';

@Component({
  selector: 'lib-delete-confirmation-popup',
  imports: [TranslocoPipe, DeleteIconComponent],
  templateUrl: './delete-confirmation-popup.component.html',
  styleUrl: './delete-confirmation-popup.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class DeleteConfirmationPopupComponent {
  isDeleteItemLoading = input<boolean>(false);
  deleteItemLabels = input<{
    deleteItemPopupTitle?: string;
    deleteItemPopupDescription?: string;
    deleteItemPopupYesButton?: string;
    deleteItemPopupNoButton?: string;
  }>({
    deleteItemPopupTitle: 'Delete Item',
    deleteItemPopupDescription: 'Are you sure you want to delete this item?',
    deleteItemPopupYesButton: 'Yes, Delete It',
    deleteItemPopupNoButton: 'No, Keep It',
  });
  deleteItem = output<void>();
  closeModal = output<void>();
}
